import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { handleValidateAndDispatchAccount, handleConnectedDepositMode, maybeTriggerSync } from '../submitUtils';

dayjs.extend(utc);

export default async function handlePensionSubmit({ formValues, dispatch, setLoading, category }) {
  const flattened = await handleConnectedDepositMode({ ...formValues }, { dispatch });

  // housekeeping: convert dates to epoch
  flattened.productPurchaseDate = dayjs.utc(formValues.productPurchaseDate).valueOf(); // required
  flattened.payoutsPhaseStart = dayjs.utc(formValues.payoutsPhaseStart).valueOf(); // required

  // convert contributionsAmountsUserInput to an array of { effectiveDate, value }
  flattened.contributionsAmounts = [{ effectiveDate: flattened.productPurchaseDate, value: flattened.contributionsAmountsUserInput }];

  let payoutsCustomIndexRate = flattened.payoutsCustomIndexRate;
  if (payoutsCustomIndexRate === '') payoutsCustomIndexRate = null;
  flattened.payoutsCustomIndexRate = payoutsCustomIndexRate !== null && payoutsCustomIndexRate !== undefined ? Number(payoutsCustomIndexRate) : payoutsCustomIndexRate;
  if (!flattened.payoutsIndexed) {
    flattened.payoutsIndexedByInflation = null;
    flattened.payoutsCustomIndexRate = null;
  } else if (flattened.payoutsIndexedByInflation) {
    flattened.payoutsCustomIndexRate = null;
  }

  // convert payoutsDurationFrequencyUserInput and payoutsDurationUserInput to payoutsDuration
  if (flattened.payoutDurationFrequencyUnitUserInput === 'indefinite') flattened.payoutsDuration = 0;
  else if (flattened.payoutDurationFrequencyUnitUserInput === 'years') flattened.payoutsDuration = 12 * flattened.payoutsDurationUserInput;
  else if (flattened.payoutDurationFrequencyUnitUserInput === 'months') flattened.payoutsDuration = flattened.payoutsDurationUserInput;

  // move quotes to intialQuotes
  flattened.initialQuotes = [];
  if (flattened.payoutOnlyContributionsToDateQuote) {
    flattened.initialQuotes.push({
      type: 'payoutOnlyContributionsToDate',
      quote: flattened.payoutOnlyContributionsToDateQuote,
      quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutOnlyContributionsToDateQuote : flattened.payoutOnlyContributionsToDateQuoteBaseCurrency,
    });
  }
  if (flattened.payoutOnlyContributionsToDateIndexedQuote) {
    flattened.initialQuotes.push({
      type: 'payoutOnlyContributionsToDateIndexed',
      quote: flattened.payoutOnlyContributionsToDateIndexedQuote,
      quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutOnlyContributionsToDateIndexedQuote : flattened.payoutOnlyContributionsToDateIndexedQuoteBaseCurrency,
    });
  }
  if (flattened.payoutAllPlannedContributionsQuote) {
    flattened.initialQuotes.push({
      type: 'payoutAllPlannedContributions',
      quote: flattened.payoutAllPlannedContributionsQuote,
      quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutAllPlannedContributionsQuote : flattened.payoutAllPlannedContributionsQuoteBaseCurrency,
    });
  }
  if (flattened.payoutAllPlannedContributionsIndexedQuote) {
    flattened.initialQuotes.push({
      type: 'payoutAllPlannedContributionsIndexed',
      quote: flattened.payoutAllPlannedContributionsIndexedQuote,
      quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutAllPlannedContributionsIndexedQuote : flattened.payoutAllPlannedContributionsIndexedQuoteBaseCurrency,
    });
  }
  if (flattened.payoutLumpSumVerrentetQuote) {
    flattened.initialQuotes.push({
      type: 'payoutLumpSumVerrentet',
      quote: flattened.payoutLumpSumVerrentetQuote,
      quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutLumpSumVerrentetQuote : flattened.payoutLumpSumVerrentetQuoteBaseCurrency,
    });
  }

  const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: flattened, dispatch, setLoading });
  const accountId = resultDispatch?.payload?.accounts?.[0]?.id;
  if (accountId) {
    maybeTriggerSync({ payload, category, dispatch, accountId });
  }
}
